import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardSidePreview from '../CardSidePreview';
import useVirtualPageView from '../../../../../../apps/pro/services/analytics/useVirtualPageView';

const propTypes = {
  className: PropTypes.string,
  cardSides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      asset_image: PropTypes.shape({
        id: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  ).isRequired,
  cardSideGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onCardSideSelect: PropTypes.func.isRequired,
};

const CardSideList = ({
  className,
  cardSides,
  onCardSideSelect,
  cardSideGroup,
}) => {
  const [loadingCardSide, setLoadingCardSide] = useState(null);
  const classes = classNames({
    'card-side-list': true,
    [className]: !!className,
  });

  useVirtualPageView({
    title: `Create a card - Select a template from ${cardSideGroup.name}`,
    path: `/template-select/${cardSideGroup.name}`,
  });

  return (
    <div className={classes}>
      {cardSides.map(cardSide => {
        return (
          <CardSidePreview
            key={cardSide.id}
            onClick={async () => {
              setLoadingCardSide(cardSide);
              await onCardSideSelect(cardSide);
              setLoadingCardSide(null);
            }}
            cardSide={cardSide}
            loading={loadingCardSide?.id === cardSide.id}
          />
        );
      })}
    </div>
  );
};

CardSideList.propTypes = propTypes;

export default CardSideList;
